var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pagination',{attrs:{"options":_vm.props.optionsObj,"records":_vm.props.records,"perPage":_vm.props.perPage,"value":_vm.props.page},on:{"input":function (page) { return _vm.props.setPage(page); }}})}
var staticRenderFns = []

export { render, staticRenderFns }